// Network calls for the QuickAddPage catalog and active-event read caches.
import type { AuthUser } from '../context/AuthContext';
import { Drink } from '../generated/drinks_pb';
import { UserData } from '../generated/user_pb';
import { drinksClient } from './drinksClient';

function buildUserData(user: AuthUser): UserData {
  const u = new UserData();
  u.setUserid(user.userId);
  u.setUsername(user.username);
  u.setToken(user.token);
  return u;
}

export async function fetchDrinkCatalog() {
  const res = await drinksClient.getDrinks(new Drink(), {});
  return res.getDrinksList().map((d) => d.toObject());
}

export async function fetchActiveEvent(user: AuthUser) {
  const res = await drinksClient.getActiveEvent(buildUserData(user), {});
  return res.toObject();
}
